module.exports = __webpack_public_path__ + "img/logo.613a2e51.png";